import * as qs from 'app/lib/helperjs';

const CONTENT_ACTIVE_CLASS = 'visible';
const BUTTON_ACTIVE_CLASS = 'showed';

const SHOW_MORE_SELECTOR = '.js-nav-show-more';
const MORE_CONTENT_SELECTOR = '.js-nav-more-content';
const OVERLAY_CLASS = 'main-nav-overlay';

export const DesktopHeaderNav = () => {
    const showMoreButton = qs.querySelector(SHOW_MORE_SELECTOR);
    const moreContent = qs.querySelector(MORE_CONTENT_SELECTOR);

    const overlay = qs.createElement('div', {
        class: OVERLAY_CLASS,
        onClick() {
            qs.removeClass(moreContent, CONTENT_ACTIVE_CLASS);
            qs.removeClass(showMoreButton, BUTTON_ACTIVE_CLASS);
            qs.removeElement(overlay);
        },
    });

    if (!showMoreButton || !moreContent) {
        return;
    }

    showMoreButton.addEventListener('click', () => {
        qs.toggleClass(moreContent, CONTENT_ACTIVE_CLASS);
        qs.addClass(showMoreButton, BUTTON_ACTIVE_CLASS);
        document.body.prepend(overlay);
    });
};
